export default __webpack_public_path__ + "static/media/saber.d5f27c7c.png";